/*
  form_upload
*/
/**
 * Desktop/Mobile form upload script
 */

 /************************************************
 	FILE UPLOAD MANAGEMENT
  On "fake" attach button click, click the real attach button
  When a file is selected, grab it's name and display it
 *************************************************/
$(".attach_btn").on("click", function() {
	$("#email_upload_file").click();
});

$("#email_upload_file").on("change", function() {

	var fileName = $(this).val();
  fileName = fileName.split("\\");
  fileName_size = fileName.length - 1;

  if (fileName[fileName_size] !== "") {
    $(".attach_name").html(fileName[fileName_size] + ' <div class="attach-addon img-icon_mob_39" style="width: 12px; height: 12px;display: inline-block; vertical-align: sub;"></div>');
  }
});
